import React from "react"
import Masthead from "./masthead"
import Footer from "./footer"
import "./style/layout.css"

const Layout = ({children, academicYear, departmentTitle, universityTitle, universityAddress, description, link, instagramLink}) => (
  <>
    <Masthead departmentTitle={departmentTitle} academicYear={academicYear} universityTitle={universityTitle} link={link} />
    {children}
    <Footer departmentTitle={departmentTitle} description={description} universityTitle={universityTitle} universityAddress={universityAddress} link={link} instagramLink={instagramLink} />
  </>
)

export default Layout